module.exports = __webpack_public_path__ + "img/TTD2025.095fda73.png";